@if (placementService.getParams() | async) {
  <!--    {{ form.value | json }}-->
  <!--    {{ form.valid }}-->
  <!--    {{ price?.errors | json }}-->
  <!--    {{ stake?.errors | json }}-->
  <form id="placementForm" [formGroup]="form" (submit)="handleSubmit()">
    <table>
      <tbody>
        <tr>
          <td colspan="4">
            <div class="overlay-wrapper">
              <div
                class="placement-form border-primary-2"
                [ngClass]="{
                  'bg-back': params?.data?.SIDE === 'BACK',
                  'bg-lay': params?.data?.SIDE === 'LAY',
                }">
                <div class="placement-row">
                  <div class="runner">
                    <mat-icon class="remove-icon" (click)="onCancel()" color="warn">close </mat-icon>
                    <span class="name text-primary"
                      >{{ params?.data?.runnerName }}
                      @if (isAsianHandicap) {
                        <span>&nbsp;{{ params?.data?.betRunner?.handicapLabel }}</span>
                      }
                    </span>
                  </div>
                  <div class="odd-ipt">
                    @if (params?.data?.PROVIDER === "SB" || params?.type === "LINE" || disableUnmatchedBets) {
                      <span class="static-price text-primary"
                        >{{ form.value?.price | number: "1.0-2" }}
                        @if (["Bookmaker", "Fancy"].includes(params?.data?.descriptionPrefix) && params?.data?.PROVIDER_ID !== "0") {
                          &nbsp;(&nbsp;{{ (params?.data?.descriptionPrefix === "Fancy" ? params?.data?.SIZE : params?.data?.PRICE) | number: "1.0-2" }}&nbsp;)
                        }
                      </span>
                    } @else {
                      <div class="custom-number-input">
                        <input
                          maxlength="7"
                          class="price-input"
                          [ngClass]="{
                            'invalid-input': isOddsInvalid,
                          }"
                          formControlName="price"
                          type="text"
                          (keydown.arrowup)="handlePriceIncrement()"
                          (keydown.arrowdown)="handlePriceDecrement()"
                          (input)="onPriceInput()"
                          (blur)="onPriceBlur()" />
                        <div class="button-container">
                          <button (focus)="priceButtonFocus = true" (blur)="priceButtonFocus = false" (click)="handlePriceIncrement()" type="button">
                            &#9650;
                          </button>
                          <button (focus)="priceButtonFocus = true" (blur)="priceButtonFocus = false" (click)="handlePriceDecrement()" type="button">
                            &#9660;
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="stake-ipt">
                    <input
                      #stakeInput
                      maxlength="7"
                      class="stake-input"
                      formControlName="stake"
                      type="text"
                      placeholder="stake"
                      [ngClass]="{
                        'invalid-input': isStakeInvalid,
                      }" />
                  </div>
                  @if (!isAsianHandicap) {
                    <span class="pt-profit text-primary">{{ potentialProfit | number: "1.2-2" }}</span>
                  }
                </div>
                @if (isAsianHandicap) {
                  <app-ah-ladder-pnl />
                }
                <div class="stake-config">
                  @for (each of stakeValues; track each) {
                    <span (click)="updateStake(each)" class="stake-btn text-primary">{{ each }}</span>
                  }
                </div>
                <div class="validation-messages">
                  @if (price?.errors?.["invalidOdd"] || price?.hasError("required") || price?.hasError("notNumber")) {
                    <b class="invalid-odd">{{ "Invalid odd" | translate }}</b>
                  }
                  @if (stake?.hasError("min") && stake?.touched && stake?.dirty) {
                    <b class="invalid-odd"
                      >{{ "The stake must be at least" | translate }}&nbsp;<b>{{ stake?.errors?.["min"]?.min }}</b></b
                    >
                  }

                  @if (stake?.hasError("max") && stake?.touched && stake?.dirty) {
                    <b class="invalid-odd"
                      >{{ "The maximum allowed stake is" | translate }}&nbsp;<b>{{ stake?.errors?.["max"]?.max }}</b></b
                    >
                  }
                  @if (stake?.hasError("required") && stake?.touched && stake?.dirty) {
                    <b class="invalid-odd">{{ "Stake is required" | translate }}</b>
                  }
                  @if (stake?.hasError("notNumber") && stake?.touched && stake?.dirty) {
                    <b class="invalid-odd">{{ "Invalid stake" | translate }}</b>
                  }
                  @if (isBalanceInsufficient && stake?.touched && stake?.dirty && stake?.value) {
                    <b class="invalid-odd">Insufficient Balance.</b>
                  }
                  <!--                    @if (errorMessage && stake?.touched && stake?.dirty && stake?.value) {-->
                  <!--                        <div class="error-message" style="color: red; margin-bottom: 8px; font-size: 12px;">-->
                  <!--                            {{ errorMessage | translate }}-->
                  <!--                        </div>-->
                  <!--                    }-->
                  <div class="fetch-statuses text-primary">
                    @let placingBet = loader.isLoading("bf_placebet") | async;
                    @let refreshingBalance = loader.isLoading("refresh_exposure") | async;
                    @let refreshingBets = loader.isLoading("current-user-order") | async;
                    <span>{{
                      placingBet ? "Placing Bet..." : refreshingBalance ? "Refreshing Balance..." : refreshingBets ? "Refreshing Open Bets..." : ""
                    }}</span>
                  </div>
                </div>
                <div class="submit-footer">
                  <button class="cancel-button text-primary" type="button" mat-button (click)="onCancel()">
                    {{ "Cancel" | translate }}
                  </button>
                  <button
                    class="btn-place-bet text-primary bg-secondary"
                    [disabled]="isSubmitDisabled || ($loading | async) || (placementService.disablePlacement$ | async) || placementResponse.timeout"
                    type="submit"
                    mat-button>
                    {{ "Place Bet" | translate }}
                  </button>
                </div>
              </div>
              @if (msgOverlay | async) {
                <app-bp-overlay [text]="'Placing your bet...'" />
              }
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </form>
  <div class="test-div" *featureFlag="'exposureCalculation'">
    <p>
      New Exposure:
      <!--      @if (debuggingService.exposureDebuggingObject | async; as debuggingObjects) {-->
      <!--        {{ getTotalExposureDebugging(debuggingObjects) | number: "1.0-2" }} /-->
      <!--          {{getExposureWhenUnmatched(debuggingObjects) | number: "1.0-2"}}-->
      <!--      }-->
      @if (debuggingService.exposureDebuggingObject | async; as debuggingObjects) {
        {{ getTotalExposureDebugging(debuggingObjects) | number: "1.0-2" }}
      }
    </p>
      <button mat-flat-button (click)="showDebugDialog($event)">Debug</button>
    <!--      @if (getExposureDebuggingResults() | async; as exposureDebugger) {-->
    <!--        <p>-->
    <!--          Total Exposure: {{ exposureDebugger.totalExposure | number: "1.1-2" }}-->
    <!--        </p>-->
    <!--        <p>-->
    <!--          Exposure Excluding this Market:-->
    <!--          {{ exposureDebugger.exposureExcludingThisMarket | number: "1.1-2" }}-->
    <!--        </p>-->
    <!--        <p>-->
    <!--          New Exposure: {{ exposureDebugger.newExposure | number: "1.1-2" }}-->
    <!--        </p>-->
    <!--      }-->
  </div>
  <!--    <p>-->
  <!--      Disable Placement:-->
  <!--      {{ placementService.disablePlacement$ | async }}-->
  <!--    </p>-->
}
